import React, { useRef, useState, useEffect } from "react";
import api from "../api";
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";

export default function PrivacyPolicy() {
    const { id } = useParams();

    const tel = id || "87475315558";

    const [phone, setPhone] = useState("");
    const [mail, setMail] = useState("");

    useEffect(() => {
        const formData = new FormData();
        formData.append("phone", tel);

        api.post("/getFranchiseeByPhone", formData, {
            headers: { "Content-Type": "application/json" },
        })
            .then(({ data }) => {
                setPhone(
                    `+7 ${data.phone.substring(1, 4)} ${data.phone.substring(
                        4,
                        7
                    )} ${data.phone.substring(7, 9)} ${data.phone.substring(9)}`
                );
                setMail(data.mail);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [tel]);

    const footerRef = useRef(null);

    const publicOffer = `ПРИЛОЖЕНИЯ «АКВАМАРКЕТ ТИБЕТСКАЯ» (Действует для пользователей, находящихся на территории Республики Казахстан)
Настоящая Оферта является официальным предложением ТОО «Partner’s Mountain Water Co» (далее – «Продавец» или «Аквамаркет Тибетская») заключить договор розничной купли-продажи Товара на нижеизложенных условиях.

Общие положения и термины
1.1. Предмет Оферты. Настоящее Соглашение является публичной офертой в соответствии с пунктом 5 статьи 395 Гражданского кодекса Республики Казахстан (ГК РК), адресованной любым дееспособным физическим или юридическим лицам (далее – «Пользователь» или «Вы») на территории Республики Казахстан, о заключении договора на условиях, изложенных в настоящем документе.
1.2. Термины:
Продавец / Аквамаркет Тибетская: ТОО «Partner’s Mountain Water Co», осуществляющее продажу и доставку Товара.
Пользователь / Вы: Физическое или юридическое лицо, использующее Приложение для оформления Заказов.
Приложение: Программное обеспечение (веб-сайт и/или мобильное приложение) «Аквамаркет Тибетская», предназначенное для оформления Заказов.
Товар: Бутилированная питьевая вода «Тибетская» объёмом 18,9 и/или 12,5 литров.
Заказ: Надлежаще оформленный запрос Пользователя на покупку и доставку Товара через Приложение.
Профиль (личный кабинет): Защищённый раздел Приложения, содержащий данные Пользователя и информацию о Заказах и Внутреннем балансе.
Внутренний баланс: Виртуальный лицевой счет Пользователя в Приложении, пополненный через Платежного оператора и предназначенный исключительно для оплаты Товара.
Платёжный оператор: ТОО «Verto Business», которое предоставляет сервис по приёму, технической обработке и проведению электронных платежей.
1.3. Акцепт Оферты. Полным и безоговорочным принятием (Акцептом) условий настоящей Оферты (согласно ст. 396 ГК РК) является любое из следующих действий Пользователя:
Регистрация и/или авторизация в Приложении;
Фактическое оформление Заказа на Товар;
Пополнение Внутреннего баланса в Приложении;
Иное явное подтверждение согласия с условиями настоящего Соглашения в интерфейсе Приложения.

2. Предмет и условия Соглашения
2.1. Продавец обязуется продать и доставить Товар, а Пользователь обязуется принять и оплатить Товар в соответствии с условиями настоящего Соглашения и ценами, указанными в Приложении.
2.2. Используя Приложение, Пользователь подтверждает, что ознакомился, понял и принимает все условия настоящей Оферты.
2.3. Территория доставки ограничена городом Алматы, если иное не указано Продавцом в Приложении.

3. Регистрация, Персональные данные и Внутренний баланс
3.1. Для оформления Заказов Пользователь обязан пройти регистрацию/авторизацию, предоставив достоверные и актуальные данные, включая ФИО/наименование организации, номер телефона, e-mail и адрес доставки.
3.2. Нажимая кнопки, подтверждающие регистрацию или оформление Заказа, Пользователь даёт согласие на обработку своих персональных данных для целей исполнения настоящего Соглашения, включая обработку Заказов, доставку, уведомления и разрешённые законом рекламные рассылки.
3.3. Внутренний баланс.Пользователь вправе пополнять свой Внутренний баланс для последующей оплаты Заказов. Все операции по пополнению обрабатываются Платёжным оператором (ТОО «Verto Business»).
3.4. Особые условия Внутреннего баланса:
Средства на Внутреннем балансе не являются депозитом, вкладом, банковским счётом или электронными деньгами.
Средства могут быть использованы только для оплаты Товара в Приложении.
В банковских выписках получателем средств будет указано ТОО «Verto Business».

4. Оформление и Оплата Заказов
4.1. Порядок оформления Заказа: 
4.1.1. Авторизация в Приложении.
4.1.2. Выбор Товара и его количества.
4.1.3. Указание адреса доставки (в пределах г. Алматы) или выбор самовывоза (если доступно).
4.1.4. Выбор способа оплаты и подтверждение Заказа. 
4.2. Оплата Товара осуществляется:
4.2.1. Путём списания средств с Внутреннего баланса.
4.2.2. Иными способами, предусмотренными Приложением.
4.3. Стоимость Товара указывается в Приложении. Продавец вправе в одностороннем порядке изменять стоимость Товара и условия доставки.
4.4. Заказ считается принятым Продавцом после подтверждения его соответствующим уведомлением в Приложении.
4.5. Возвраты ошибочных транзакций (пополнения баланса) осуществляет Платёжный оператор в соответствии с законодательством Республики Казахстан.

5. Доставка, Приемка и Возврат Товара
5.1. Продавец обязуется осуществить доставку Товара по адресу, указанному Пользователем, в сроки и время, выбранные Пользователем из доступных опций в Приложении. Сроки доставки носят ориентировочный характер.
5.2. Приемка Товара. При получении Товара Пользователь обязан проверить:
5.2.1. Целостность заводской упаковки и тары.
5.2.2. Соответствие количества бутылей оформленному Заказу.
5.3. В случае обнаружения явных повреждений или несоответствия по количеству, Пользователь вправе отказаться от приемки такого Товара, составив соответствующий акт совместно с представителем службы доставки.
5.4. Право собственности и риск случайной гибели или порчи Товара переходит к Пользователю в момент фактической передачи Товара и подписания сопроводительных документов (при наличии).
5.5. Возврат Товара ненадлежащего качества. В случае обнаружения скрытых недостатков Товара после его приемки, Пользователь вправе предъявить претензии в порядке и сроки, установленные Законом РК «О защите прав потребителей».

6. Гарантии и Ответственность Сторон
6.1. Продавец гарантирует, что Товар соответствует требованиям действующего законодательства РК, включая СТ РК 1432-2005, и санитарно-гигиеническим нормам, подтверждающим качество питьевой воды.
6.2. Продавец не несет ответственность за любой ущерб, возникший у Пользователя по причине:
Недостоверности или неактуальности данных, предоставленных Пользователем. 
Нарушения Пользователем условий настоящего Соглашения.
Технических сбоев, вызванных обстоятельствами, не зависящими от Продавца (сбои на стороне операторов связи, провайдеров и пр.).
6.3. Пользователь несет ответственность за сохранность своих учетных данных и любые действия, совершенные с использованием его Профиля.

7. Изменение, Расторжение Соглашения и Возврат остатка Баланса
7.1. Изменение Оферты. Продавец вправе в одностороннем порядке изменять условия настоящей Оферты без предварительного уведомления. Новая редакция вступает в силу с момента размещения в Приложении или на сайте: www.tibetskaya.kz/PublicOffer.
7.2. Расторжение. Пользователь вправе в любой момент удалить свой Профиль, направив письменный запрос Продавцу.
7.3. Возврат остатка Внутреннего баланса. В случае удаления Профиля, Пользователь имеет право потребовать возврата неиспользованного остатка средств со своего Внутреннего баланса. Продавец обязуется осуществить такой возврат в течение 10 (десяти) рабочих дней с момента получения запроса. Удаление профиля не освобождает Пользователя от обязательств по уже подтвержденным и неоплаченным Заказам.
7.4. Продавец вправе заблокировать или удалить учетную запись Пользователя в случае нарушения условий Оферты или законодательства РК, или при наличии признаков мошенничества.

8. Разрешение Споров и Прочие условия
8.1. Все споры и разногласия, возникающие в связи с исполнением настоящего Соглашения, решаются путем переговоров и предъявления письменных претензий. Срок рассмотрения претензии — 10 (десять) календарных дней.
8.2. В случае недостижения соглашения, спор передается на рассмотрение суда Республики Казахстан по месту регистрации Продавца.
8.3. Во всем, что прямо не урегулировано настоящим Соглашением, Стороны руководствуются действующим законодательством Республики Казахстан.

9. Реквизиты
ТОО «Verto Business»
БИН: 220340005670
Адрес: Республика Казахстан, 050045, г. Алматы,
мкр. Нурлытау, ул. Г. Баязитовой, д. 12
ИИК: KZ1596521F0008530262
АО "ForteBank"
БИК: IRTYKZKA
Тел.: +7 (701) 531-55-58
`

    const formattedPublicOffer = publicOffer.split('\n').map((paragraph, index) => {
        if (paragraph.trim() === "") return null; // Пропускаем пустые строки
        return paragraph.startsWith(' ') ? <p key={index}>{paragraph.trim()}</p> : <h3 key={index}>{paragraph.trim()}</h3>;
    });

    return (
        <div className="flex flex-col min-h-screen justify-between">
            <div className="pt-5 px-5 space-y-3">
                <h2 className="text-lg font-bold">ПУБЛИЧНАЯ ОФЕРТА (ПРЕДЛОЖЕНИЕ)</h2>
                {formattedPublicOffer}
            </div>

            <div className="">
                <Footer ref={footerRef} phone={phone} mail={mail} />
            </div>
        </div>
    );
}
